import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div
      className="login-page"
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg, #1B4D2A 0%, #0f2d18 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      {/* Decorative circles */}
      <div
        style={{
          position: 'fixed',
          top: -120,
          right: -120,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'rgba(200,167,90,0.06)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'fixed',
          bottom: -80,
          left: -80,
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'rgba(200,167,90,0.05)',
          pointerEvents: 'none',
        }}
      />

      <div
        style={{
          width: '100%',
          maxWidth: 420,
          background: 'rgba(255,255,255,0.97)',
          borderRadius: 20,
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          overflow: 'hidden',
        }}
      >
        {/* Green header section */}
        <div
          style={{
            background: '#1B4D2A',
            padding: '28px 32px 24px',
            textAlign: 'center',
          }}
        >
          <img
            src="/logo-admin.png"
            alt="مسجد الموسوي - الادارة"
            style={{ width: 120, height: 120, objectFit: 'contain', borderRadius: 20 }}
          />
        </div>

        {/* Form section */}
        <div style={{ padding: '28px 32px 32px' }}>
          <p style={{ color: '#6c757d', fontSize: '0.88rem', textAlign: 'center', marginBottom: 20 }}>
            تسجيل الدخول لإدارة المحتوى
          </p>

          {error && (
            <Alert variant="danger" className="d-flex align-items-center" style={{ fontSize: '0.88rem' }}>
              <i className="bi bi-exclamation-triangle ms-2"></i>
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: '0.88rem' }}>
                <i className="bi bi-envelope ms-1"></i>
                البريد الإلكتروني
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="أدخل البريد الإلكتروني"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label style={{ fontSize: '0.88rem' }}>
                <i className="bi bi-lock ms-1"></i>
                كلمة المرور
              </Form.Label>
              <Form.Control
                type="password"
                placeholder="أدخل كلمة المرور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              type="submit"
              className="w-100"
              disabled={loading}
              style={{
                background: '#1B4D2A',
                border: 'none',
                borderRadius: 10,
                padding: '12px',
                fontSize: '0.95rem',
                fontWeight: 700,
              }}
            >
              {loading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" className="ms-2" />
                  جاري تسجيل الدخول...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-left ms-1"></i>
                  تسجيل الدخول
                </>
              )}
            </Button>
          </Form>

          <div className="text-center mt-4">
            <small style={{ color: '#adb5bd', fontSize: '0.78rem' }}>
              <i className="bi bi-shield-check ms-1"></i>
              منصة آمنة ومحمية
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
